import { LOAD_MODAL_CONTAINER, CLOSE_MODAL_CONTAINER, LOAD_MESSAGE_MODAL } from '../constants/ActionTypes';

// Show Prompt up for login navigation
const loadModalContainer = channel =>
  dispatch => dispatch({
    type: LOAD_MODAL_CONTAINER,
    payload: channel,
  });

const closeModalContainer = () =>
  dispatch => dispatch({ type: CLOSE_MODAL_CONTAINER });

// Showing message by showing Modal prompt
const loadMessageModal = payload => ({
  type: LOAD_MESSAGE_MODAL,
  payload,
});

module.exports = {
  loadModalContainer,
  closeModalContainer,
  loadMessageModal,
};
